import "./Sources.styles.scss";
import React from "react";
import { RichTextDisplayField } from "components";

type SourcesProps = {
  sources: string;
};

const Sources = ({ sources }: SourcesProps) => {
  if (!sources) return null;

  return (
    <div className="sources">
      <div className="sources__divider"></div>
      <div className="sources__title">References</div>
      <RichTextDisplayField value={sources} />
    </div>
  );
};

export default Sources;
